"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
const firestore_2 = require("@react-query-firebase/firestore");
/**
 *
 * @param firestore
 * @param uid del usuario principal
 * @param dependantUid uid del dependant, sino hay nada se infiere que sólo se utiliza el usuario principal.
 * Tener extremo cuidado al usar usePatient para obtener un dependant, los obtiene de la ruta dependants/${uid_dependant} y no de users/${uid}/dependants/${uid_dependant}
 */
function usePatient(firestore, uid, dependantUid, firestoreOptions, queryOptions) {
    const path = dependantUid ? `dependants/${dependantUid}` : `user/${uid}`;
    const docRef = (0, firestore_1.doc)(firestore, path);
    return (0, firestore_2.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.User({
        name: "patient",
        path: path
    }, [uid, dependantUid ?? "false"]), docRef, firestoreOptions, queryOptions);
}
exports.default = usePatient;
